{
  "show": {
    "title": "Measurement and Feedback",
    "feedback_title": "Student Feedback",
    "self_assessment": "Self Assessment",
    "comments": "Comments",
    "empty_commnents_title": "No Comments Yet...",
    "empty_commnents_description": "Feedback and comments from students will appear here once submitted."
  },
  "categories": {
    "clarity_of_message": "Clarity of Message",
    "knowledge_of_subject": "Knowledge of Subject",
    "speed_of_turnaround_of_work": "Speed of Turnaround of Work",
    "availability_reliability": "Availability and Reliability",
    "ability_to_motivate_inspire": "Ability to Motivate and Inspire",
    "create_an_interest_in_subject": "Create an Interest in Subject",
    "outcome_better_than_expected": "Outcome Better Than Expected",
    "ability_to_relate_to_students": "Ability to Relate to Students",
    "empathy": "Empathy",
    "use_cutting_edge_methods": "Use Cutting-Edge Methods",
    "style_autocratic": "Autocratic",
    "style_consultative": "Consultative",
    "style_participative": "Participative",
    "style_reserved": "Reserved",
    "style_talk": "Talkative"
  },

  "average_rating": "{{average}} / {{max}}",
  "ratings_count_one": "{{count}} rating",
  "ratings_count_other": "{{count}} ratings",
  "stars_one": "{{count}} star",
  "stars_other": "{{count}} stars"
}
